'use strict';

module.exports = function (ngModule) {
    ngModule.filter('makeRange', require('./makerange'))
}


/** WEBPACK FOOTER **
 ** ./src/pages/filters/makerange/index.js
 **/